import { useState, useEffect } from 'react';
import { useDappState } from './useDappState';

const PRO_BANNER_DISMISSED_KEY = 'pro_banner_dismissed';

export const useProBanner = () => {
  const { isPro } = useDappState();
  const [isDismissed, setIsDismissed] = useState(false);

  // Check if user has dismissed the ad on hook mount
  useEffect(() => {
    const dismissed = sessionStorage.getItem(PRO_BANNER_DISMISSED_KEY);
    if (dismissed === 'true') {
      setIsDismissed(true);
    }
  }, []);

  // Function to dismiss the ad
  const dismissAd = () => {
    sessionStorage.setItem(PRO_BANNER_DISMISSED_KEY, 'true');
    setIsDismissed(true);
  };

  return {
    showBannerAd: isPro === false && !isDismissed,
    dismissAd,
  };
};
